import React, { useMemo } from 'react';
import { APITypes } from '../../../../../primary-record-types';
import { Form } from '../../../../v2BaseComponents/Form';
import { handleFormikSubmit } from '../../../../../utils/handleFormikSubmit';
import GroupFields from '../../../../shared/Groups/GroupFields';

export type EditGroupFormOwnProps = {
    group: APITypes.organizationService.OrganizationGroupDetails;
    onUpdate: (group: APITypes.organizationService.UpdateOrganizationGroupRequest) => void;
    isDisabled: boolean;
    onCancel: () => void;
};

export type EditGroupFormProps = EditGroupFormOwnProps;

const EditGroupForm: React.FC<EditGroupFormProps> = (props) => {
    const initialValues = useMemo<APITypes.organizationService.UpdateOrganizationGroupRequest>(
        () => ({
            name: props.group.metadata.name,
            description: props.group.metadata.description || '',
            address1: props.group.contactDetails.address1,
            address2: props.group.contactDetails.address2,
            city: props.group.contactDetails.city,
            state: props.group.contactDetails.state,
            zipCode: props.group.contactDetails.zipCode,
        }),
        [props.group],
    );

    return (
        <Form
            fillContainer
            actionContainerSubmit
            initialValues={initialValues}
            onSubmit={(values, helpers) => {
                props.onUpdate(values);
                handleFormikSubmit(values, helpers);
            }}
            isDisabled={props.isDisabled}
            onCancel={props.onCancel}
        >
            {() => <GroupFields isDisabled={props.isDisabled} />}
        </Form>
    );
};

export default React.memo(EditGroupForm);
